export default function Footer() {
  return (
    <footer data-testid="footer" className="bg-cream border-t border-navy/10 py-12">
      <div className="max-w-[1400px] mx-auto px-6 lg:px-10 grid grid-cols-1 md:grid-cols-3 gap-8 items-start">
        <div>
          <div className="font-serif-display text-2xl">UNNATI</div>
          <div className="font-mono-data text-[10px] uppercase tracking-[0.22em] opacity-60 mt-1">DPI · Capacity Building · Bharat</div>
          <p className="text-sm text-navy/70 mt-4 max-w-sm">A connective intelligence layer for India's Central and State training institutes.</p>
        </div>
        <div className="text-sm">
          <div className="font-mono-data text-xs uppercase tracking-[0.2em] text-navy/50 mb-3">Ecosystem</div>
          <ul className="space-y-1.5 text-navy/80">
            <li>iGOT Karmayogi</li>
            <li>Amrit Gyaan Kosh</li>
            <li>CSTIs &amp; State ATIs</li>
          </ul>
        </div>
        <div className="text-sm">
          <div className="font-mono-data text-xs uppercase tracking-[0.2em] text-navy/50 mb-3">Strategic Pillars</div>
          <ul className="space-y-1.5 text-navy/80">
            <li>Demand · Delivery · Knowledge</li>
            <li>Continuous learning engine</li>
            <li>Open APIs · Sandbox</li>
          </ul>
        </div>
      </div>
      <div className="max-w-[1400px] mx-auto px-6 lg:px-10 mt-10 border-t border-navy/10 pt-6 flex flex-wrap gap-3 justify-between text-xs text-navy/50 font-mono-data uppercase tracking-[0.18em]">
        <span>© {new Date().getFullYear()} UNNATI Blueprint</span>
        <span>Institutional Backbone · Version 1.0</span>
      </div>
    </footer>
  );
}
